import React, { useState, useEffect, createContext, useRef, lazy } from "react";
import ReactDOM from "react-dom/client";
import CoworkingStepOne from "./Coworking/Step_1";

const CoworkingStepTwoImport = () => import("./Coworking/Step_2");
const CoworkingStepTwo = lazy(CoworkingStepTwoImport);

const CoworkingStepThreeImport = () => import("./Coworking/Step_3");
const CoworkingStepThree = lazy(CoworkingStepThreeImport);

const CoworkingStepFourImport = () => import("./Coworking/Step_4_Checkout");
const CoworkingStepFour = lazy(CoworkingStepFourImport);

const CoworkingStepFiveImport = () => import("./Coworking/Step_5");
const CoworkingStepFive = lazy(CoworkingStepFiveImport);

const CoworkingStepSix = lazy(() => import("./Coworking/Step_6"));

import CoworkingHeader from "./Coworking/Header";
import CoworkingFooter from "./Coworking/Footer";
import {
  dataLayerStep1,
  dataLayerStep2,
  dataLayerStep3,
  dataLayerStep4,
  dataLayerStep5,
} from "./functions/datalayer";
import { calculateVAT, getNextValidDate } from "./functions/coworking";

export const WizardContext = createContext();

const WizardPanel = () => {
  if (Object.keys(CoworkingWizardData).length == 0) {
    return;
  }
  const [clientSecret, setClientSecret] = useState("");
  const [cart, setCart] = useState({});
  const payButtonRef = useRef(null);

  const [headerTitle, setHeaderTitle] = useState("Your membership plan");
  const [prevStep, setPrevStep] = useState(0);
  const [nextStep, setNextStep] = useState(2);

  const [wizardModal, setWizardModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [oldStep, setOldStep] = useState(0);

  const [homeLocation, setHomeLocation] = useState(
    CoworkingWizardData.homeLocation
  );
  const [homeLocationTemplateSlug, setHomeLocationTemplateSlug] = useState(
    CoworkingWizardData.homeLocationTemplateSlug
  );
  const [teamSize, setTeamSize] = useState(1);
  const [teamOption, setTeamOption] = useState("solo");
  const [locationType, setLocationType] = useState("single");
  const [howOftenDays, setHowOftenDays] = useState(1);
  const [howOften, setHowOften] = useState("week");
  const [paymentOption, setPaymentOption] = useState("rolling_monthly");
  const [planType, setPlanType] = useState("flex");

  const now = new Date();
  const initStartDate = new Date(
    now.getHours() >= 12 ? now.setDate(now.getDate() + 1) : now
  );
  const [startDate, setStartDate] = useState(getNextValidDate(initStartDate));

  const [priceWithoutExtra, setPriceWithoutExtra] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [firstMonthPrice, setFirstMonthPrice] = useState(0);

  const [locationError, setLocationError] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [billingEmailAddress, setBillingEmailAddress] = useState("");
  const [billingCompanyName, setBillingCompanyName] = useState("");

  const [billingAddress, setBillingAddress] = useState("");
  const [billingAddress1, setBillingAddress1] = useState("");
  const [billingAddress2, setBillingAddress2] = useState("");
  const [billingCity, setBillingCity] = useState("");
  const [billingCounty, setBillingCounty] = useState("");
  const [billingCountry, setBillingCountry] = useState("United Kingdom");
  const [billingPostcode, setBillingPostcode] = useState("");
  const [billingSuggestions, setBillingSuggestions] = useState([]);

  const [memberTermsAccepted, setMemberTermsAccepted] = useState("");
  // const [marketingConsent, setMarketingConsent] = useState("");

  const [errors, setErrors] = useState({});

  const [strikePriceSubscription, setStrikePriceSubscription] = useState(0);
  const [bestValueSubscription, setBestValueSubscription] = useState("");

  const [midMonthPrice, setMidMonthPrice] = useState(0);
  const [midMonthExtraPrice, setMidMonthExtraPrice] = useState(0);

  useEffect(() => {
    jQuery(".appStep1").removeClass("visible");
    jQuery(".appStep2").removeClass("visible");
    jQuery(".appStep3").removeClass("visible");
    jQuery(".appStep4").removeClass("visible");
    jQuery(".appStep5").removeClass("visible");
    setOldStep(currentStep);
    if (currentStep === 1) {
      CoworkingStepTwoImport();
      setPrevStep(0);
      setNextStep(2);
      setHeaderTitle("Your membership plan");
    }
    if (currentStep === 2) {
      CoworkingStepThreeImport();
      setPrevStep(1);
      setNextStep(3);
      setHeaderTitle("Choose your extras");
      if (currentStep > oldStep) {
        dataLayerStep1(
          locationType,
          howOften,
          howOftenDays,
          homeLocation,
          teamSize
        );
      }
    }
    if (currentStep === 3) {
      CoworkingStepFourImport();
      setPrevStep(2);
      setNextStep(4);
      setHeaderTitle("Summary");
      if (currentStep > oldStep) {
        dataLayerStep2(cart);
      }
    }
    if (currentStep === 4) {
      CoworkingStepFiveImport();
      setPrevStep(3);
      setNextStep("last");
      setHeaderTitle("Your details");
      if (currentStep > oldStep) {
        const vatPrice = calculateVAT(firstMonthPrice);
        const finalPrice = (Number(firstMonthPrice) + Number(vatPrice)).toFixed(
          2
        );
        dataLayerStep3(startDate, planType, paymentOption, finalPrice);
      }
    }
    if (currentStep === 5) {
      setHeaderTitle("Payment");
      if (currentStep > oldStep) {
        dataLayerStep4();
      }
    }
    if (currentStep === 6) {
      if (currentStep > oldStep) {
        dataLayerStep5(planType);
      }
    }
    setTimeout(() => {
      jQuery(".appStep" + currentStep).addClass("visible");
    }, 100);
  }, [currentStep]);

  useEffect(() => {
    window.openWizardModal = () => {
      setWizardModal("CoWorking");
    };
    window.handleStayBtnClick = () => {
      jQuery(".wizardCloseModalPopup").removeClass("popupOpen");
      jQuery(".wizardCloseModalPopup").fadeOut();
    };

    window.handlePopupClose = () => {
      jQuery(".wizardCloseModalPopup").fadeIn();
      jQuery(".wizardCloseModalPopup").addClass("popupOpen");
    };

    window.resetStateDom = () => {
      handleStayBtnClick();
      resetState();
    };

    window.setCoworkingData = () => {
      setHomeLocation(
        CoworkingWizardData.homeLocationTemplateSlug == ""
          ? CoworkingWizardData.homeLocation
          : ""
      );
      setTeamSize(CoworkingWizardData.teamSize);
      setTeamOption(CoworkingWizardData.teamSize == 1 ? "solo" : "team");
      setHowOften(CoworkingWizardData.howOften);
      setHowOftenDays(CoworkingWizardData.howOftenDays);
      setPaymentOption(CoworkingWizardData.paymentOption);
      setPlanType(CoworkingWizardData.planType);
      setHomeLocationTemplateSlug(CoworkingWizardData.homeLocationTemplateSlug);
      setLocationType(
        CoworkingWizardData.homeLocationTemplateSlug == ""
          ? "single"
          : "all_locations"
      );
    };
  }, []);

  // useEffect(() => {
  //   if (!wizardModal) {
  //     resetState();
  //   }
  // }, [wizardModal]);

  const resetState = () => {
    if (payButtonRef.current) {
      payButtonRef.current = null;
    }
    setClientSecret("");
    setCart({});
    setHomeLocation(CoworkingWizardData.homeLocation);
    setHomeLocationTemplateSlug(CoworkingWizardData.homeLocationTemplateSlug);
    setTeamSize(1);
    setTeamOption("solo");
    setLocationType("single");
    setHowOftenDays(1);
    setHowOften("week");
    setPaymentOption("rolling_monthly");
    setPlanType("flex");
    setStartDate(getNextValidDate(initStartDate));
    setPriceWithoutExtra(0);
    setFinalPrice(0);
    setFirstMonthPrice(0);
    setLocationError(false);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setCompanyName("");
    setBillingEmailAddress("");
    setBillingCompanyName("");
    setBillingAddress("");
    setBillingAddress1("");
    setBillingAddress2("");
    setBillingCity("");
    setBillingCounty("");
    setBillingCountry("United Kingdom");
    setBillingPostcode("");
    setBillingSuggestions([]);
    setMemberTermsAccepted("");
    // setMarketingConsent("");
    setErrors({});
    setWizardModal(false);
    setCurrentStep(1);
    setStrikePriceSubscription(0);
    setBestValueSubscription("");
    setMidMonthPrice(0);
    setMidMonthExtraPrice(0);

    jQuery("#wizard-root").fadeOut();
    jQuery("body").removeClass("wizard-open");
  };

  return (
    <WizardContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        wizardModal,
        setWizardModal,
        homeLocation,
        setHomeLocation,
        teamSize,
        setTeamSize,
        teamOption,
        setTeamOption,
        locationType,
        setLocationType,
        howOftenDays,
        setHowOftenDays,
        howOften,
        setHowOften,
        paymentOption,
        setPaymentOption,
        planType,
        setPlanType,
        locationError,
        setLocationError,
        cart,
        setCart,
        clientSecret,
        setClientSecret,
        startDate,
        setStartDate,
        priceWithoutExtra,
        setPriceWithoutExtra,
        finalPrice,
        setFinalPrice,
        firstMonthPrice,
        setFirstMonthPrice,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        email,
        setEmail,
        phone,
        setPhone,
        companyName,
        setCompanyName,
        billingEmailAddress,
        setBillingEmailAddress,
        billingCompanyName,
        setBillingCompanyName,
        billingAddress,
        setBillingAddress,
        billingAddress1,
        setBillingAddress1,
        billingAddress2,
        setBillingAddress2,
        billingCity,
        setBillingCity,
        billingCounty,
        setBillingCounty,
        billingCountry,
        setBillingCountry,
        billingPostcode,
        setBillingPostcode,
        billingSuggestions,
        setBillingSuggestions,
        memberTermsAccepted,
        setMemberTermsAccepted,
        // marketingConsent,
        // setMarketingConsent,
        errors,
        setErrors,
        resetState,
        payButtonRef,
        initStartDate,

        strikePriceSubscription,
        setStrikePriceSubscription,
        bestValueSubscription,
        setBestValueSubscription,
        midMonthPrice,
        setMidMonthPrice,
        midMonthExtraPrice,
        setMidMonthExtraPrice,
      }}
    >
      {wizardModal == "CoWorking" && (
        <div className="coworkingWizardOptions">
          {currentStep < 6 && <CoworkingHeader title={headerTitle} />}
          {currentStep === 1 && <CoworkingStepOne />}
          {currentStep === 2 && <CoworkingStepTwo />}
          {currentStep === 3 && <CoworkingStepThree />}
          {currentStep === 4 && <CoworkingStepFour />}
          {currentStep === 5 && <CoworkingStepFive />}
          {currentStep === 6 && <CoworkingStepSix />}
          {currentStep < 5 && (
            <CoworkingFooter
              prevStep={prevStep}
              nextStep={nextStep}
              nextBtnLabel={currentStep === 4 ? "Checkout" : "Next"}
            />
          )}
        </div>
      )}
    </WizardContext.Provider>
  );
};

const rootElement = document.getElementById("wizard-root");
const root = ReactDOM.createRoot(rootElement);
root.render(<WizardPanel />);
